import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddressBookComponent } from './addressbook.component';
import { BusinessComponent } from './business/business.component';

const routes: Routes = [
   {
      path: '',
      component: AddressBookComponent,
      children: [
         { path: 'new', component: BusinessComponent },
         { path: ':action/:id', component: BusinessComponent },

         { path: '**', redirectTo: 'new' },
         { path: '', pathMatch: 'full', redirectTo: 'new' },
      ]
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule]
})
export class AddressbookRoutingModule { }
